import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

// Register the useGSAP hook and any other plugins globally (optional but good practice)
// This avoids re-registering on every component re-render.
gsap.registerPlugin(useGSAP); // register the hook to avoid React version discrepancies